import React from "react";
import { useState, useEffect } from "react";
import Button from "../../../components/button";
import { useUserContext } from "../../../context/userContext";
import { useCallback } from "react";
import { listAllCompaniess } from "../../../api/backofficeAPI";

import TenantTable from "../../components/backofficeAdmin/backoffice/TenantTable";
import TenantDrawer from "../../components/backofficeAdmin/drawer/TenantDrawer";
import Loading from "../../../components/loading";

import PageControls from "../../../components/pageControls";
import PaginationControls from "../../../components/paginationControls";
import ErrorState from "../../../components/errorState";
import { Wrapper } from "./style";

const TeamSystemBackoffice = () => {
  const [tenantList, setTenantList] = useState([]);
  const [tenant, setTenant] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPageNumber, setTotalPageNumber] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [requestError, setRequestError] = useState(false);
  const { myUser } = useUserContext();

  const getData = useCallback(() => {
    const data = {
      pageNumber: pageNumber,
      pageSize: rowsPerPage,
      filters: [],
      sorting: [],
      fieldsToInclude: [],
    };

    setIsLoading(true);

    listAllCompaniess(data).then((response) => {
      if (response.status === 200) {
        setTenantList(response.data.data);
        setTotalPageNumber(response.data.totalPages);
        setTotalRecords(response.data.totalRecords);
        setIsLoading(false);
      } else {
        setRequestError(true);
        setIsLoading(false);
      }
    });
  }, [pageNumber, rowsPerPage]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleDrawer = (bool) => {
    setIsOpen(bool);
  };

  const decreasePageNumber = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const onRighePerPaginaChange = (e) => {
    setRowsPerPage(e.target.value);
    setPageNumber(1);
  };

  return (
    <Wrapper>
      <div className="content">
        {!isLoading && tenantList.length > 0 && !requestError && (
          <div className="button-container">
            <Button
              primary
              className="button"
              onClick={() => {
                setIsOpen(true);
                setIsNew(true);
              }}
            >
              Nuovo Tenant
            </Button>
          </div>
        )}
        <PageControls
          getData={getData}
          refreshData={() => {}}
          //totalPageNumber={totalPageNumber}
          //pageNumber={pageNumber}
          //setPageNumber={setPageNumber}
          //decreasePageNumber={decreasePageNumber}
          //rowsPerPage={rowsPerPage}
          //onRighePerPaginaChange={onRighePerPaginaChange}
          //totalRecords={totalRecords}
        />

        <TenantTable
          isLoading={isLoading}
          tenantList={tenantList}
          requestError={requestError}
          setIsNew={setIsNew}
          setIsOpen={setIsOpen}
          setTenant={setTenant}
        />

        <PaginationControls
          getData={getData}
          refreshData={() => {}}
          totalPageNumber={totalPageNumber}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          decreasePageNumber={decreasePageNumber}
          rowsPerPage={rowsPerPage}
          onRighePerPaginaChange={onRighePerPaginaChange}
          totalRecords={totalRecords}
        />

        {isLoading && !requestError && (
          <div className="loading-container">
            <Loading large />
          </div>
        )}

        {!tenantList.length && requestError && !isLoading && (
          <ErrorState
            text={
              "A causa di un errore non e stato possibile ricevere la lista dei Tenant."
            }
          />
        )}

        <TenantDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isNew={isNew}
          handleDrawer={handleDrawer}
          myUser={myUser}
          getData={getData}
          tenant={tenant}
        />
      </div>
    </Wrapper>
  );
};

export default TeamSystemBackoffice;
